import { PRODUCT, PROJECT, TEST_PLAN_NAME, INFO, JIRA } from './addTestPlanForm.fields';

export const FORM_CONFIG = {
  [PRODUCT.id]: PRODUCT,
  [PROJECT.id]: PROJECT,
  [TEST_PLAN_NAME.id]: TEST_PLAN_NAME,
  [INFO.id]: INFO,
  [JIRA.id]: JIRA,
};
